<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <v-row align="center">
        <v-col class="text-right" >
          <v-btn outlined class="mr-2" @click="setTimeAllInBranchModal = true">Задать время для филиала</v-btn>
          <v-btn @click="$router.push({ name: 'workshop-create'})">Создать цех</v-btn>
        </v-col>
      </v-row>
      <v-data-table
              no-data-text="Нет улиц"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="workshops"
              v-model="selected"
              :search="search"
              :fixed-header="true"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              height="60vh"
              :options.sync="options"
              :footer-props="footerProps"
              :loading="loading"
              loading-text="Загрузка улиц... Подождите пожалуйста"
      >

        <template v-slot:item="{item,index}">
          <tr class="grouped-row">
            <td>
              <template>
                <v-icon class="mr-2" v-if="item.show" @click="item.show = false">mdi-chevron-up</v-icon>
                <v-icon class="mr-2" v-else @click="item.show = true">mdi-chevron-down</v-icon>
              </template>
              {{ item.name }}
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                          small
                          class="mr-2"
                          v-bind="attrs"
                          v-on="on"
                  >
                    mdi-dots-vertical
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item @click="$router.push({ name: 'workshop-edit', params: { id: item.id } })">
                    <v-list-item-title>Редактировать</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="submitDialog = true; submitItem = item">
                    <v-list-item-title>Удалить</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
          <template>
            <tr v-for="branch in branches" v-if="item.show" :class="{'changed-row': isChangedRow(item, branch)}" :key="item.id + '_' + branch.id">
              <td class="pl-13">{{ branch.name }}</td>
              <td>
                <v-chip
                        class="mr-2 time-chip"
                        label
                >
                  {{ getTime(getBranchWorkshop(item, branch).delivery_time) }}
                  <v-icon right small dark @click="resetTime(item, branch)">
                    mdi-close-circle
                  </v-icon>
                </v-chip>
                <span @click="changeTime(item, branch, -5)" class="plus-minus-btn">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                    <circle cx="12" cy="12" r="11.5" fill="white" stroke="#EAF0F6"/>
                    <rect x="17" y="11" width="2" height="10" transform="rotate(90 17 11)" fill="#B4BDC6"/>
                  </svg>
                </span>
                <span @click="changeTime(item, branch, 5)" class="plus-minus-btn">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="11.5" fill="white" stroke="#EAF0F6"/>
                    <rect x="11.166" y="7" width="2" height="10" fill="#B4BDC6"/>
                    <rect x="17" y="11.166" width="2" height="10" transform="rotate(90 17 11.166)" fill="#B4BDC6"/>
                  </svg>
                </span>
              </td>
              <td>
                <v-simple-checkbox @click="toggleDisabled(item, branch)" :value="getBranchWorkshop(item, branch).is_disabled ? true : false"></v-simple-checkbox>
              </td>
              <td></td>
            </tr>
          </template>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
                  v-if="submitItem == null"
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  v-else
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
            v-model="setTimeAllInBranchModal"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Задать время для всего филиала
        </v-card-title>

        <v-card-text>
          <v-select
              label="Филиал"
              :items="branches"
              v-model="setForBranch"
              :item-text="branch => branch.name"
              :item-value="branch => branch.id"
              outlined>
          </v-select>


          <div>
            <v-chip
                class="mr-2 time-chip"
                label
            >
              {{ getTime(this.timeForBranch) }}
              <v-icon right small dark @click="resetBranchTime()">
                mdi-close-circle
              </v-icon>
            </v-chip>
            <span @click="changeBranchTime(-5)" class="plus-minus-btn">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                    <circle cx="12" cy="12" r="11.5" fill="white" stroke="#EAF0F6"/>
                    <rect x="17" y="11" width="2" height="10" transform="rotate(90 17 11)" fill="#B4BDC6"/>
                  </svg>
                </span>
            <span @click="changeBranchTime(5)" class="plus-minus-btn">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="11.5" fill="white" stroke="#EAF0F6"/>
                    <rect x="11.166" y="7" width="2" height="10" fill="#B4BDC6"/>
                    <rect x="17" y="11.166" width="2" height="10" transform="rotate(90 17 11.166)" fill="#B4BDC6"/>
                  </svg>
                </span>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn
              :disabled="!setForBranch"
              @click="saveForBranch()">
            Подтвердить
          </v-btn>
          <v-btn
              outlined
              @click="setTimeAllInBranchModal = false; setForBranch = null"
          >
            Отменить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import WorkshopService from '../../../api/WorkshopService'
    import BranchService from "../../../api/BranchService";
    import AreaService from "../../../api/AreaService";
    import moment from 'moment'

    export default {
        name: 'ProductIndex',
        components: {},
        data: () => ({
            setTimeAllInBranchModal: false,
            setForBranch: null,
            timeForBranch: '00:20:00',
            overlay: false,
            search: '',
            loadingModal: false,
            loading: true,
            tab: null,
            dialog: false,
            selected: [],
            submitDialog: false,
            submitItem: null,
            workshops: [],
            branches: [],
            options: {},
            footerProps: {
                itemsPerPageText: 'Тегов на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
                itemsPerPageOptions: [-1]
            },
            totalProducts: 0,
            headers: [
                {
                    text: 'Группа',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Время приготовления',
                    value: 'area.name',
                    sortable: false
                },
                {
                  text: 'Выключен',
                  value: 'area.name',
                  sortable: false
                },
                {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
            ],
        }),
        mounted() {
          BranchService.list().then(response => {
            this.branches = response.data;
          })
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
        },
        methods: {
          saveForBranch() {

            for (const item of this.workshops) {

              let branchWorkshop = this.getBranchWorkshop(item, {id: this.setForBranch})
              branchWorkshop.delivery_time = this.timeForBranch;

              WorkshopService.update({
                id: item.id,
                data: item.data
              }).then(response => {

              })
            }

            this.setForBranch = null;
            this.setTimeAllInBranchModal = false;
          },
          submitDelete(item = null){
            if(item){
              this.removeWorkshop(item)
            } else {
              //this.massDelete()
            }
          },
          getTime(time){
            return moment('2020-01-01 ' + time).format('HH:mm')
          },
            isChangedRow(item, branch){
              let branchWorkshop = this.getBranchWorkshop(item, branch)
              if(branchWorkshop.delivery_time == item.default_delivery_time){
                return false;
              }
              return true;
            },
            getBranchWorkshop(item, branch){
                if(item.data.find(branchWorkshop => branchWorkshop.id == branch.id)){
                  return item.data.find(branchWorkshop => branchWorkshop.id == branch.id);
                }

                item.data.push({
                  delivery_time: item.default_delivery_time ,
                  id: branch.id
                })

                return item.data.find(branchWorkshop => branchWorkshop.id == branch.id);
            },
          resetBranchTime() {
            this.timeForBranch = '00:20:00';
          },
            resetTime(item, branch){
              let branchWorkshop = this.getBranchWorkshop(item, branch)
              branchWorkshop.delivery_time = item.default_delivery_time

              WorkshopService.update({
                id: item.id,
                data: item.data,
              }).then(response => {
              })
            },
            changeBranchTime(time) {
              this.timeForBranch = moment('2020-01-01 ' + this.timeForBranch).add(time, 'm').format('HH:mm:ss');

            },
            changeTime(item, branch, time){
              let branchWorkshop = this.getBranchWorkshop(item, branch)
              branchWorkshop.delivery_time = moment('2020-01-01 ' + branchWorkshop.delivery_time).add(time, 'm').format('HH:mm:ss')

              WorkshopService.update({
                id: item.id,
                data: item.data
              }).then(response => {

              })
            },
            toggleDisabled(item, branch){
              let branchWorkshop = this.getBranchWorkshop(item, branch)
              branchWorkshop.is_disabled = branchWorkshop.is_disabled ? false : true;

              WorkshopService.update({
                id: item.id,
                data: item.data
              }).then(response => {

              })
            },
            removeWorkshop(item){
              WorkshopService.remove(item.id).then(response => {
                  this.loading = true
                  this.getDataFromApi()
              })
            },
            getDataFromApi() {
                this.loading = true

                WorkshopService.list({})
                    .then(response => {
                        this.workshops = response.data
                        this.loading = false
                    })
            },
        }
    }
</script>

<style>
  .changed-row{
    background-color: #FFEEEC;
  }
</style>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }


  .grouped-row td:first-child {
    font-weight: bold;
    font-size: 16px !important;
    font-family: Consolas, sans-serif;
    letter-spacing: 1px;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
